export const map = (from, mapped, checkEmpty) => {
    if (from !== null && from !== undefined) {
        if (checkEmpty && (from === '' || from.length === 0)) return null;
        return { [mapped]: from };
    }
    return null;
};
